import { useLayoutEffect, useRef, useState } from 'react';

// radix Dialog/Drawer content walls off body portals: they stack under it,
// lose pointer events, and lose wheel to its scroll lock. Render in-flow there.
// Popper content (Popover) also has role=dialog but carries data-side; skip it.
const RADIX_DIALOG = '[role="dialog"][data-state]:not([data-side])';

const bodyPortal = () =>
  typeof document === 'undefined' ? undefined : document.body;

const inFlowPopupContainer = (trigger: HTMLElement) =>
  trigger.parentElement ?? document.body;

/** antd `getPopupContainer`: decides from the trigger node at open time. */
export const dialogAwarePopupContainer = (trigger: HTMLElement) =>
  trigger.closest(RADIX_DIALOG) ? inFlowPopupContainer(trigger) : document.body;

/** Same, for popups opened from inside an antd Dropdown menu: mount on the
 * dropdown root so clicks in the popup never bubble into `Menu.onSelect`. */
export const dialogAwareMenuPopupContainer = (trigger: HTMLElement) =>
  trigger.closest(RADIX_DIALOG)
    ? (trigger.closest<HTMLElement>('.ant-dropdown') ??
      inFlowPopupContainer(trigger))
    : document.body;

/** react-select `menuPortalTarget`: needs a mounted node, so attach `ref`. */
export const useDialogHostedMenuPortal = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [inDialog, setInDialog] = useState(false);

  useLayoutEffect(() => {
    setInDialog(ref.current?.closest(RADIX_DIALOG) != null);
  }, []);

  return { ref, menuPortalTarget: inDialog ? null : bodyPortal() };
};
